import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

const Notifications = () => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/settings").then(({ data }) => setS(data)).catch((e) => toast.error(formatErr(e))); }, []);

  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/settings", s); setS(data); toast.success("Ustawienia powiadomień zapisane"); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  const test = async () => {
    setBusy(true);
    try { const { data } = await api.post("/settings/test-email"); toast.success(`Wysłano testowy e-mail na ${data.to}`); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };

  if (!s) return null;
  return (
    <div className="fe-group" style={{ marginTop: 24 }} data-testid="settings-notifications">
      <p className="label">Powiadomienia e-mail o nowych zapytaniach</p>
      <label className="check"><input type="checkbox" checked={s.notify_enabled} onChange={(e) => setS({ ...s, notify_enabled: e.target.checked })} data-testid="settings-notify-enabled" />Wysyłaj e-mail przy każdym nowym zapytaniu</label>
      <div className="fe-field"><label>Adres e-mail</label><input type="email" value={s.notify_email} onChange={(e) => setS({ ...s, notify_email: e.target.value })} data-testid="settings-notify-email" /></div>
      <div className="fe-actions" style={{ flexWrap: "wrap" }}>
        <button className="btn solid" onClick={save} disabled={busy} data-testid="settings-save-notify-btn">Zapisz</button>
        <button className="btn line" onClick={test} disabled={busy} data-testid="settings-test-email-btn">Wyślij testowy e-mail</button>
      </div>
      <p className="adm-sub" style={{ margin: 0, fontSize: 14 }}>Najpierw zapisz adres, a potem wyślij test. Sprawdź też folder spam.</p>
    </div>
  );
};

export const Settings = ({ user }) => {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (nw.length < 6) return toast.error("Nowe hasło musi mieć min. 6 znaków");
    setBusy(true);
    try { await api.post("/auth/change-password", { current_password: cur, new_password: nw }); setCur(""); setNw(""); toast.success("Hasło zmienione"); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };

  return (
    <div data-testid="admin-settings" style={{ maxWidth: 560 }}>
      <h1>Ustawienia</h1>
      <p className="adm-sub">Zalogowano jako {user.email}</p>
      <Notifications />
      <div className="fe-group" style={{ marginTop: 24 }}>
        <p className="label">Zmiana hasła</p>
        <div className="fe-field"><label>Obecne hasło</label><input type="password" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="settings-current-password" /></div>
        <div className="fe-field"><label>Nowe hasło</label><input type="password" value={nw} onChange={(e) => setNw(e.target.value)} data-testid="settings-new-password" /></div>
        <button className="btn solid" style={{ justifySelf: "start" }} onClick={submit} disabled={busy} data-testid="settings-save-password-btn">Zmień hasło</button>
      </div>
    </div>
  );
};
